import { get } from 'lodash';
import moment from 'moment-timezone';
import { EmailItem, EmailItemAttachement, FolderItem } from '.';

/**
 * Replaces all inline attachements of an email body with data base64 encoded
 * images.
 */
export const replaceInlineAttachments = (
  content: string,
  attachments: EmailItemAttachement[],
): string => {
  for (const attachment of attachments) {
    const regexp = new RegExp(
      `"cid:${attachment.contentId}@?[a-zA-Z0-9\.]*?"`,
      'g',
    );
    content = content.replace(
      regexp,
      `"data:${attachment.contentType};base64,${attachment.contentBytes}"`,
    );
  }
  return content;
};

/**
 * Retrieves the inbox folder from a list of folders
 */
export const getInboxFolder = (folders: FolderItem[]): FolderItem | null => {
  return folders.find(folder => folder.wellKnownName === 'inbox') || null;
};

/**
 * Adds target="_blank" to all links of the given document.
 * Used to make sure links in emails do not open in the wrapper iframe.
 */
export const addTargetBlankToLinks = (document: Document) => {
  document.querySelectorAll('a').forEach(link => {
    const href = link.getAttribute('href');

    if (href && !href.startsWith('#')) {
      link.setAttribute('target', '_blank');
    }
  });
};

/**
 * Renders the date besides an email overview list item and email details.
 */
export const getDateLabel = (email: EmailItem): string => {
  const sentDate = get(email, 'sentDateTime', '');

  if (sentDate === '') {
    return '';
  }

  return moment(sentDate).format('HH:mm');
};

export const getDateDetailsLabel = (email: EmailItem): string => {
  const sentDate = get(email, 'sentDateTime', '');

  if (sentDate === '') {
    return '';
  }

  const momentDate = moment(sentDate);
  return momentDate.format('dd DD.MM.YYYY HH:mm');
};

export const isValidEmail = (email: string): boolean => {
  const pattern =
    // eslint-disable-next-line no-useless-escape
    /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;
  return pattern.test(String(email).toLowerCase());
};

/**
 * Downloads a JS file blob.
 */
export const downloadBlob = (blob: Blob, filename: string) => {
  const file = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', file);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.append(link);
  link.click();
  link.remove();
};
